import React, { Component } from "react";
import { connect } from "react-redux";
import MuiPhoneNumber from "material-ui-phone-number";
import Doorman from "./doorman.png";
import { Button } from "@material-ui/core";
import instance from "../../store/actions/instance";
import { isValidPhoneNumber } from "react-phone-number-input";
import { CircularProgress, TextField } from "@material-ui/core";
import { changeLanguage, saveCustomerContact } from "../../store/actions";

const isVirginPhoneNumber = (phone) => {
  // For Virgin Mobile Kuwait. Numbers are 8 digits long and start with 41
  if (!phone) return false;
  if (
    phone.startsWith("+965") &&
    phone.split("+965")[1].startsWith("41") &&
    phone.split("+965")[1].length === 8
  )
    return true;
  return false;
};

class Index extends Component {
  state = {
    phoneError: false,
    phoneFieldKey: Math.random() * 99999,
    countryDialCode: "",
    phone: "",
    checkLoading: false,

    code: "",
    codeError: false,

    name: "",
    email: "",

    canJoin: false,
    alreadyJoined: false,
    verifyPhone: false,

    joinLoading: false,
    joinedSuccess: false,

    emailError: false,
  };

  validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  getOnlyCountries = () => {
    const { settings } = this.props;

    return settings.show_all_country_codes
      ? []
      : [
          "kw",
          "sa",
          "qa",
          "om",
          "ae",
          "bh",
          "sy",
          "lb",
          "jo",
          "eg",
          "us",
          "uk",
          "cn",
        ];
  };

  t = (text) => {
    const { language } = this.props;
    if (language === "english") return text;

    const trans = {
      Phone: "رقم الهاتف",
      "Invalid phone number": "رقم الهاتف غير صحيح",
      "Invalid login credentials": "بيانات الدخول غير صحيحة. حاول مرة اخرى",
      Register: "التسجيل",
      Login: "تسجيل الدخول",
      OR: "أو",
      "A SMS was sent to": "تم ارسال رسالة نصية الى",
      "with a 4 digit verification code. Please enter it below":
        "مع رمز تحقق مكون من 4 رموز. قم بإدخاله ادناه",
      "Invalid verification code": "رمز تحقق خاطئ",
      "Please enter verification code": "الرجاء ادخال رمز التحقق",
      "Confirmation code": "رمز التحقق",
      Verify: "اتمام التحقق",
      "Forgot password?": "نسيت كلمة المرور؟",
      "Send me an OTP": "ارسل رمز تحقق",
      "This shop is exclusive to invited members. Enter your phone number below to verify your eligibility to place an order.":
        "هذا المتجر حصري للأعضاء المدعوين فقط. ادخل رقم هاتفك للتحقق من امكانية دخولك.",

      "You are not a member but you can join the waitlist. Enter your details below":
        "أنت لست عضوًا، لكن يمكنك الانضمام إلى قائمة الانتظار. أدخل بياناتك أدناه.",
      Name: "الاسم",
      Email: "الايميل",
      "Join the waitlist": "التسجيل",
      "Go back": "الرجوع",
      "You have already joined the waitlist. We will get back to you soon.":
        "لقد انضممت بالفعل إلى قائمة الانتظار. سنعود إليك قريبًا.",
      "You have joined the waitlist successfully! You will be notified soon":
        "لقد انضممت إلى قائمة الانتظار بنجاح! سيتم إشعارك قريبًا.",
    };
    return trans[text] || text;
  };

  handleChange = (e, eventPhone) => {
    const { settings } = this.props;

    if (eventPhone) {
      this.setState({ countryDialCode: eventPhone.dialCode });
    }
    if (typeof e == "string") {
      if (e.startsWith("+" + eventPhone.dialCode)) {
        this.setState({ phone: e });
      } else {
        this.setState({ phoneFieldKey: Math.random() * 999999 });
      }
      if (e.length != this.state.phone.length)
        this.setState({ phoneError: false });
    }
  };

  isPhoneValid = () => {
    if (
      (!isValidPhoneNumber(this.state.phone) &&
        !isVirginPhoneNumber(this.state.phone)) ||
      this.state.countryDialCode == this.state.phone.substring(1)
    ) {
      this.setState({ phoneError: true });
      return false;
    }
    return true;
  };
  check = async () => {
    if (!this.isPhoneValid()) return;
    this.setState({ checkLoading: true });
    try {
      const res = await instance.post("/check_teaser_availability/", {
        phone: this.state.phone,
      });
      if (res.data.success) {
        try {
          const res2 = await instance.post("/send_phone_verification/", {
            number: this.state.phone,
            resend: false,
            language: this.props.language,
          });
          if (res2.data.success || res2.data.message === "too early")
            this.setState({
              verifyPhone: true,
              canJoin: false,
              joinedSuccess: false,
              alreadyJoined: false,
            });
        } catch (e) {
          console.error(e);
        }
      } else if (res.data.case === 2)
        this.setState({
          alreadyJoined: true,
          verifyPhone: false,
          canJoin: false,
          joinedSuccess: false,
        });
      else if (res.data.case === 3)
        this.setState({
          canJoin: true,
          verifyPhone: false,
          joinedSuccess: false,
          alreadyJoined: false,
        });
    } catch (e) {
      console.error(e);
    }
    this.setState({ checkLoading: false });
  };

  getStep = () => {
    if (this.state.verifyPhone) return 1;
    if (this.state.joinedSuccess) return 4;
    if (this.state.canJoin) return 3;
    if (this.state.alreadyJoined) return 2;

    return 0;
  };

  verify = async () => {
    if (this.state.code?.length !== 4) {
      this.setState({ codeError: this.t("Invalid verification code") });
      return;
    }
    this.setState({ verifyLoading: true });

    try {
      const res = await instance.post("/verify_phone/", {
        number: this.state.phone,
        code: this.state.code,
        fromTeasers: true,
      });
      if (res.data.success) {
        if (this.state.canJoin) {
          const res2 = await instance.post("/join_teasers/", {
            phone: this.state.phone,
            name: this.state.name,
            email: this.state.email,
            language: this.props.language,
          });
          if (res2.data.success) {
            this.setState({
              joinedSuccess: true,
              verifyPhone: false,
              canJoin: false,
            });
          }
        } else {
          // This is where the shop opens
          localStorage.setItem("customerID", res.data.key);
          this.props.saveCustomerContact({ phone: this.state.phone });
          this.props.history.replace("/");
        }
      } else this.setState({ codeError: this.t("Invalid verification code") });
    } catch (e) {
      console.error(e);
    }
    this.setState({ verifyLoading: false });
  };

  reset = () => {
    this.setState({
      canJoin: false,
      alreadyJoined: false,
      verifyPhone: false,

      phoneError: false,
      phoneFieldKey: Math.random() * 99999,
      countryDialCode: "",
      phone: "",
      checkLoading: false,

      code: "",
      codeError: false,

      name: "",
      email: "",

      joinLoading: false,
      joinedSuccess: false,

      emailError: false,
    });
  };

  join = async () => {
    if (!this.state.phone) {
      this.setState({ phoneError: true });
      return;
    }
    if (this.state.email) {
      const emailValid = this.validateEmail(this.state.email);
      if (!emailValid) {
        this.setState({ emailError: true });
        return;
      }
    }
    this.setState({ joinLoading: true });

    try {
      try {
        const res2 = await instance.post("/send_phone_verification/", {
          number: this.state.phone,
          resend: false,
          language: this.props.language,
        });
        if (res2.data.success || res2.data.message === "too early")
          this.setState({ verifyPhone: true });
      } catch (e) {
        console.error(e);
      }
    } catch (e) {
      console.error(e);
    }
    this.setState({ joinLoading: false });
  };
  render() {
    const { settings, store, language, themeColor } = this.props;

    const inputLabelStyle = {
      transformOrigin: language === "english" ? "top left" : "top right",
      right: language === "arabic" ? 0 : "unset",
      left: language === "english" ? 0 : "unset",
    };
    const step = this.getStep();
    return (
      <>
        <Button
          className="back_arrow mt-1 languageMakeDisappearForLargeScreen"
          onClick={() => {
            this.props.changeLanguage();
            window.scrollBy(0, 1);
            window.scrollBy(0, -1);
          }}
          style={{
            fontSize: 20,
            color: "black",
            fontFamily: this.props.language == "arabic" && "Quicksand",
            fontFamily: this.props.language === "english" && "none",
            top: 20,
            [language === "english" ? "right" : "left"]: 15,
            position: "absolute",
          }}
        >
          {this.props.language == "english" ? "ع" : "En"}
        </Button>
        <div
          style={{
            display: "grid",
            justifyItems: "center",
            alignItems: "center",
            height: "100vh",
            background: "white",
          }}
        >
          <div style={{ maxWidth: "90%" }}>
            <div className="mb-4">
              <img
                src={Doorman}
                alt="exclusive"
                style={{ width: 180, height: 180 }}
              />
            </div>

            {step === 0 && (
              <div>
                <p className="bold">
                  {this.t(
                    "This shop is exclusive to invited members. Enter your phone number below to verify your eligibility to place an order."
                  )}
                </p>
                <MuiPhoneNumber
                  defaultCountry={store.default_dial_code || "kw"}
                  onlyCountries={this.getOnlyCountries()}
                  excludeCountries={["il"]}
                  countryCodeEditable={false}
                  disableAreaCodes={true}
                  error={this.state.phoneError}
                  label={language === "english" ? "Phone *" : "رقم الهاتف *"}
                  className="mt-4 mb-3"
                  color={"#0099cc"}
                  onChange={this.handleChange}
                  key={this.state.phoneFieldKey}
                  value={this.state.phone}
                  autoComplete="tel"
                  fullWidth
                  helperText={
                    this.state.phoneError
                      ? language === "english"
                        ? "Please enter your phone number"
                        : "الرجاء ادخال رقم الهاتف"
                      : ""
                  }
                  FormHelperTextProps={{
                    style: {
                      textAlign: language === "arabic" && "right",
                      marginRight: language === "arabic" && 5,
                    },
                  }}
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                />
                <div>
                  <Button
                    variant="contained"
                    className="my-4"
                    style={{
                      backgroundColor: themeColor,
                      color: "white",
                      width: 250,
                      height: 50,
                    }}
                    size="large"
                    disableElevation
                    onClick={() => this.check()}
                  >
                    {!this.state.checkLoading ? (
                      <span className="bold">
                        {language == "english" ? "Check" : "التحقق"}
                      </span>
                    ) : (
                      <span>
                        <CircularProgress
                          style={{ width: 30, height: 30, color: "white" }}
                        />
                      </span>
                    )}
                  </Button>
                </div>
              </div>
            )}

            {step === 1 && (
              <div>
                <p className="bold">
                  {this.t("A SMS was sent to")}{" "}
                  <span style={{ fontWeight: "bold" }}>{this.state.phone}</span>{" "}
                  {this.t(
                    "with a 4 digit verification code. Please enter it below"
                  )}
                </p>

                <TextField
                  fullWidth
                  label={this.t("Confirmation code")}
                  required
                  value={this.state.code.toLowerCase()}
                  onChange={(e) =>
                    this.setState({
                      code: e.target.value,
                      codeError: false,
                    })
                  }
                  error={!!this.state.codeError}
                  helperText={
                    typeof this.state.codeError === "string"
                      ? this.state.codeError
                      : undefined
                  }
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  InputProps={{
                    dir: language === "english" ? "ltr" : "rtl",
                    style: { textTransform: "lowercase" },
                  }}
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                />
                <Button
                  variant="contained"
                  className="my-4 mb-3"
                  style={{
                    backgroundColor: themeColor,
                    color: "white",
                    width: 250,
                    height: 50,
                  }}
                  size="large"
                  disableElevation
                  onClick={() => this.verify()}
                >
                  {!this.state.verifyLoading ? (
                    <span className="bold">{this.t("Verify")}</span>
                  ) : (
                    <span>
                      <CircularProgress
                        style={{ width: 30, height: 30, color: "white" }}
                      />
                    </span>
                  )}
                </Button>

                <div>
                  {" "}
                  <Button
                    variant="link"
                    style={{
                      width: 250,
                      height: 50,
                      color: themeColor,
                    }}
                    size="large"
                    disableElevation
                    onClick={() => this.reset()}
                  >
                    <span className="bold">{this.t("Go back")}</span>
                  </Button>
                </div>
              </div>
            )}

            {step === 2 && (
              <div>
                <p className="bold">
                  {this.t(
                    "You have already joined the waitlist. We will get back to you soon."
                  )}
                </p>

                <Button
                  variant="link"
                  className="my-4"
                  style={{
                    width: 250,
                    height: 50,
                    color: themeColor,
                  }}
                  size="large"
                  disableElevation
                  onClick={() => this.reset()}
                >
                  <span className="bold">{this.t("Go back")}</span>
                </Button>
              </div>
            )}

            {step === 3 && (
              <div>
                <p className="bold">
                  {this.t(
                    "You are not a member but you can join the waitlist. Enter your details below"
                  )}
                </p>

                <MuiPhoneNumber
                  defaultCountry={store.default_dial_code || "kw"}
                  onlyCountries={this.getOnlyCountries()}
                  excludeCountries={["il"]}
                  countryCodeEditable={false}
                  disableAreaCodes={true}
                  error={this.state.phoneError}
                  label={language === "english" ? "Phone *" : "رقم الهاتف *"}
                  className="mt-4 mb-3"
                  color={"#0099cc"}
                  onChange={this.handleChange}
                  key={this.state.phoneFieldKey}
                  value={this.state.phone}
                  autoComplete="tel"
                  fullWidth
                  helperText={
                    this.state.phoneError
                      ? language === "english"
                        ? "Please enter your phone number"
                        : "الرجاء ادخال رقم الهاتف"
                      : ""
                  }
                  FormHelperTextProps={{
                    style: {
                      textAlign: language === "arabic" && "right",
                      marginRight: language === "arabic" && 5,
                    },
                  }}
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                />

                <TextField
                  fullWidth
                  label={this.t("Name")}
                  value={this.state.name}
                  onChange={(e) =>
                    this.setState({
                      name: e.target.value,
                    })
                  }
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  InputProps={{
                    dir: language === "english" ? "ltr" : "rtl",
                    style: { textTransform: "lowercase" },
                  }}
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                />

                <TextField
                  className="mt-3"
                  fullWidth
                  label={this.t("Email")}
                  value={this.state.email.toLowerCase()}
                  onChange={(e) =>
                    this.setState({
                      email: e.target.value,
                      emailError: false,
                    })
                  }
                  error={!!this.state.emailError}
                  helperText={
                    typeof this.state.emailError === "string"
                      ? this.state.emailError
                      : undefined
                  }
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  InputProps={{
                    dir: language === "english" ? "ltr" : "rtl",
                    style: { textTransform: "lowercase" },
                  }}
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                />

                <Button
                  variant="contained"
                  className="mb-3 mt-5"
                  style={{
                    backgroundColor: themeColor,
                    color: "white",
                    width: 250,
                    height: 50,
                  }}
                  size="large"
                  disableElevation
                  onClick={() => this.join()}
                >
                  {!this.state.joinLoading ? (
                    <span className="bold">{this.t("Join the waitlist")}</span>
                  ) : (
                    <span>
                      <CircularProgress
                        style={{ width: 30, height: 30, color: "white" }}
                      />
                    </span>
                  )}
                </Button>

                <div>
                  <Button
                    variant="link"
                    style={{
                      width: 250,
                      height: 50,
                      color: themeColor,
                    }}
                    size="large"
                    disableElevation
                    onClick={() => this.reset()}
                  >
                    <span className="bold">{this.t("Go back")}</span>
                  </Button>
                </div>
              </div>
            )}

            {step === 4 && (
              <div>
                <p className="bold">
                  {this.t(
                    "You have joined the waitlist successfully! You will be notified soon"
                  )}
                </p>

                <Button
                  variant="link"
                  className="my-4"
                  style={{
                    width: 250,
                    height: 50,
                    color: themeColor,
                  }}
                  size="large"
                  disableElevation
                  onClick={() => this.reset()}
                >
                  <span className="bold">{this.t("Go back")}</span>
                </Button>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    settings: state.store.store.settings,
    language: state.store.language,
    store: state.store.store,
    themeColor: state.store.store.settings.dark || "#0099cc",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveCustomerContact: (customer) => dispatch(saveCustomerContact(customer)),
    changeLanguage: () => dispatch(changeLanguage()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
